import attachedDocuments from './attachedDocuments';

export default {
  groupId: 'attachedDocuments',
  groupName: 'encounter:widget.attachedDocuments.title',
  widgets: { [attachedDocuments.id]: attachedDocuments }
};
